// extracted by mini-css-extract-plugin
module.exports = {"root":"IconMail_root__1V8tH"};